'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import Image from 'next/image';
import EventListIcon from '@/assets/icons/event_list.svg';
import { useExplore } from './ExploreProvider';
const viewOptions = [{
  id: 'map',
  label: 'Map',
  icon: active => <svg className={`w-5 h-5 transition-colors duration-300 ${active ? 'text-[#323232]' : 'text-white'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
}, {
  id: 'list',
  label: 'List',
  icon: active => <Image src={EventListIcon} alt="" width={20} height={20} className={`w-5 h-5 transition-colors duration-300 ${active ? 'brightness-0' : 'brightness-0 invert'}`} />
}];
export function ViewToggle() {
  const $ = _c(13);
  const {
    viewMode,
    setViewMode,
    setHeartsScope
  } = useExplore();
  const [showOnMobile] = useState(true);
  const [, setIsMobile] = useState(false);
  const isMapView = viewMode === "map";
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const checkMobile = () => setIsMobile(window.innerWidth < 768);
      checkMobile();
      window.addEventListener("resize", checkMobile);
      return () => {
        window.removeEventListener("resize", checkMobile);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== setHeartsScope || $[3] !== setViewMode) {
    t2 = value => {
      setViewMode(value);
      if (value === "list") {
        setHeartsScope("all");
      }
    };
    $[2] = setHeartsScope;
    $[3] = setViewMode;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleChangeMode = t2;
  const t3 = `fixed left-0 right-0 mx-auto z-40 transition-all duration-300 bottom-4 max-w-fit ${showOnMobile ? "flex" : isMapView ? "lg:flex hidden" : "flex"}`;
  let t4;
  if ($[5] !== handleChangeMode || $[6] !== viewMode) {
    t4 = viewOptions.map(option => {
      const isActive = viewMode === option.id;
      return <button data-id={`view-toggle-${option.id}`} key={option.id} onClick={() => handleChangeMode(option.id)} className={`flex items-center gap-2 lg:px-6 px-3.5 lg:py-3.75 py-2.5 rounded-[100px] transition-all duration-300 ease-in-out cursor-pointer ${isActive ? "bg-[#00EAFD] backdrop-blur-[4.15px] text-[#323232] rounded-[124px] shadow-[-2px_2px_24px_0px_rgba(0,0,0,0.1)]" : "text-white hover:bg-white/10 opacity-50 hover:opacity-75"}`}>{option.icon(isActive)}<span className={`lg:text-base text-[15px] font-medium transition-colors duration-300 ${isActive ? "text-[#323232]" : "text-white"}`}>{option.label}</span></button>;
    });
    $[5] = handleChangeMode;
    $[6] = viewMode;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className="flex items-center bg-[rgba(0,0,0,0.4)] gap-0.5 p-0.5 backdrop-blur-[4.15px] rounded-[124px] shadow-[-2.5px_2.5px_24.8px_0px_rgba(0,0,0,0.1)]">{t4}</div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}

// Individual toggle button component for composability
export function ViewToggleButton(t0) {
  const $ = _c(18);
  const {
    viewId,
    label,
    iconSrc,
    iconAlt: t1,
    isActive,
    onClick
  } = t0;
  const iconAlt = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== onClick || $[1] !== viewId) {
    t2 = () => onClick(viewId);
    $[0] = onClick;
    $[1] = viewId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `flex flex-col items-center justify-center p-3 rounded-[100px] transition-colors cursor-pointer ${isActive ? "bg-blue-50 text-blue-600" : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"}`;
  const t4 = isActive ? "#1C1B1F" : "#D5D5D5";
  const t5 = `url(${iconSrc?.src ?? iconSrc})`;
  const t6 = `url(${iconSrc?.src ?? iconSrc})`;
  let t7;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = {
      width: 20,
      height: 20,
      backgroundColor: t4,
      maskImage: t5,
      WebkitMaskImage: t6,
      maskRepeat: "no-repeat",
      WebkitMaskRepeat: "no-repeat",
      maskSize: "contain",
      WebkitMaskSize: "contain"
    };
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== iconAlt || $[8] !== t7) {
    t8 = <span role="img" aria-label={iconAlt} className="inline-block transition-colors duration-300" style={t7} />;
    $[7] = iconAlt;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = `text-xs mt-1 font-medium ${isActive ? "text-blue-600" : "text-gray-500"}`;
  let t10;
  if ($[10] !== label || $[11] !== t9) {
    t10 = <span className={t9}>{label}</span>;
    $[10] = label;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t2 || $[15] !== t3 || $[16] !== t8) {
    t11 = <button onClick={t2} className={t3}>{t8}{t10}</button>;
    $[13] = t10;
    $[14] = t2;
    $[15] = t3;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}